/**
 * Frontend feature toggles (no backend changes).
 * Set to true to show AI survey entry points and admin survey response pages again.
 */
export const FEATURE_AI_SURVEY_UI_ENABLED = false;

/**
 * Build-time walkthrough kill switch. When false, tours never run regardless of admin setting.
 * Admin on/off: System Configuration → Admin Settings → feature_flag_walkthrough_enabled.
 * Set REACT_APP_WALKTHROUGH_ENABLED=false to hard-disable without redeploying admin DB value.
 */
export const WALKTHROUGH_BUILD_ENABLED =
  String(process.env.REACT_APP_WALKTHROUGH_ENABLED || '').trim().toLowerCase() !== 'false';

/**
 * Build-time walkthrough sync kill switch.
 * Admin on/off: System Configuration → Admin Settings → feature_flag_walkthrough_sync_enabled.
 */
export const WALKTHROUGH_SYNC_BUILD_ENABLED =
  String(process.env.REACT_APP_WALKTHROUGH_SYNC_ENABLED || '').trim().toLowerCase() !== 'false';

/** @deprecated Use useFeatureFlags().isWalkthroughEnabled */
export const WALKTHROUGH_ENABLED = WALKTHROUGH_BUILD_ENABLED;

/** @deprecated Use useFeatureFlags().isWalkthroughSyncEnabled */
export const WALKTHROUGH_SYNC_ENABLED = WALKTHROUGH_SYNC_BUILD_ENABLED;
